var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"loading-content"},[_c('BpCustomColorLogo',{attrs:{"width":"120","height":"60"}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }